import React, {Component} from "react";
import {Navbar} from "react-bootstrap";
import PropTypes from "prop-types";
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";

import routes from "routes/app.jsx";


class AdminNavbar extends Component {
    getActiveRoute = routes => {
        let activeRoute = "Infomed";
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = this.getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else {
                if (
                    window.location.href.indexOf(routes[i].path) !== -1
                ) {
                    return routes[i].name;
                }
            }
        }
        return activeRoute;
    };
    mobileSidebarToggle = () => {
        document.documentElement.classList.toggle("nav-open");
    };

    render() {
        return (
            <Navbar fluid className={this.props.navbar ? "navbar-fixed" : ""}>
                <div className="navbar-minimize">
                    <button
                        id="minimizeSidebar"
                        className="btn btn-default btn-fill btn-round btn-icon"
                        onClick={this.props.handleMiniClick}
                    >
                        <i className="fa fa-ellipsis-v visible-on-sidebar-regular"/>
                        <i className="fa fa-navicon visible-on-sidebar-mini"/>
                    </button>
                </div>
                <Navbar.Header>
                    <Navbar.Brand>
                        {/* Here we create navbar brand, based on route name */}
                        <a href="#pablo">{this.getActiveRoute(routes)}</a>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.mobileSidebarToggle}/>
                </Navbar.Header>

                {/* Here we import the links that appear in navbar */}
                {window.innerWidth > 992 ? (
                    <Navbar.Collapse>
                        <AdminNavbarLinks history={this.props.history}/>
                    </Navbar.Collapse>
                ) : null}
            </Navbar>
        );
    }
}

AdminNavbar.propTypes = {
    navbar: PropTypes.bool,
    handleMiniClick: PropTypes.func,
    history: PropTypes.object
};

export default AdminNavbar;
